// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty-cart[data-v-1acb2c97]{display:flex;flex-direction:column;align-items:center;margin:auto}.empty-cart .empty-title[data-v-1acb2c97]{color:#1c1c1c;font-size:25px;font-weight:500;line-height:30px;text-align:center;margin-bottom:32px}.empty-cart img[data-v-1acb2c97]{max-width:700px}@media(max-width:601px){.empty-cart img[data-v-1acb2c97]{width:80%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
